module.exports = __webpack_public_path__ + "static/media/LogoPathogens.101130e7.png";